// extracted by mini-css-extract-plugin
export default {"container":"b0zOR157eKjf2qHrwioo"};